import React, { useEffect } from 'react'
import ATMLocatorContainer from '../containers/ATMLocator'
import Nav from '../components/nav/Nav';

const ATMLocator: React.FC= () => {

  useEffect(() => {
    document.title = 'Elite Community CU | ATM Locators';

    const metaDescription = document.createElement('meta');
    metaDescription.name = 'description';
    metaDescription.content = "Never Fret About Fees Find a free ATM with any of the ATM locators below...";
    document.head.appendChild(metaDescription);
  }, []);

  return (
    <div>
      <Nav />
      <ATMLocatorContainer />
    </div>
  )
}

export default ATMLocator